import React from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { marketUrl } from '~/constants/market'
import { TrophyPrivateMemoryCard } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyPrivateMemoryCard'
import { TrophyMemoryCardSkeleton } from '~/modules/TrophyMemories/Infrastructure/Components/TrophyMemoryCardSkeleton'
import styles from './TrophyPrivateMemoryCardList.module.scss'

interface Props {
  seriesId: string
  collectionAddress: string
  tokenId: string
  numMemories: number
}

export const TrophyPrivateMemoryCardList: React.FC<Props> = ({ seriesId, collectionAddress, tokenId, numMemories }) => {
  const { t } = useTranslation('trophy_memories')

  const numberOfSkeletonMemories = 5 - numMemories

  const privateMemories = Array.from(
    Array(numMemories).keys()
  ).map((index) => (<TrophyPrivateMemoryCard key={ index }/>))

  const skeletonMemories = Array.from(
    Array(numberOfSkeletonMemories).keys()
  ).map((index) => (<TrophyMemoryCardSkeleton key={ numMemories + index } />))

  return (
    <div>
      <div className={ styles.trophyPrivateMemoryCardList__description }>
        <p>
          <Trans
            i18nKey={ t('private_description_1') }
            components={ [
              <strong key="strong"/>,
            ] }
          />
        </p>
        <p>
          <Trans
            i18nKey={ t('private_description_2') }
            components={ [
              <a
                key="market-link"
                className={ styles.trophyPrivateMemoryCardList__description__link }
                href={ `${marketUrl}/series/${seriesId}/${collectionAddress}/${tokenId}` }
                target="_blank"
                rel="noreferrer"
              />,
            ] }
          />
        </p>
      </div>

      <div className={ styles.trophyPrivateMemoryCardList__container }>
        { privateMemories }
        { skeletonMemories }
      </div>
    </div>
  )
}
